import { syncCheckoutContext } from "./syncCheckoutContext";
import { connectCheckoutEvents, disableCheckoutEvents } from "./checkoutEvents";

let initialized = false;

export async function startOpenReplay(): Promise<void> {
  if (!import.meta.env.PROD || initialized) return;
  initialized = true;

  const projectKey = import.meta.env.VITE_OPEN_REPLAY_PROJECT_KEY?.trim();
  if (!projectKey) {
    disableCheckoutEvents();
    console.warn("[OpenReplay] VITE_OPEN_REPLAY_PROJECT_KEY não configurada.");
    return;
  }

  try {
    // Carrega a gravação em paralelo à abertura do checkout.
    const [{ default: Tracker }, { default: trackerAssist }] = await Promise.all([
      import("@openreplay/tracker"),
      import("@openreplay/tracker-assist"),
    ]);

    const tracker = new Tracker({
      projectKey,
      defaultInputMode: 1,
      // Logs e requisições do checkout podem conter dados pessoais e de pagamento.
      consoleMethods: [],
      network: {
        capturePayload: false,
        ignoreHeaders: true,
        sessionTokenHeader: false,
        failuresOnly: false,
        captureInIframes: false,
      },
    });

    tracker.use(trackerAssist({
      callConfirm: {
        text: "Um atendente deseja iniciar uma chamada com você. Aceitar?",
        confirmBtn: "Aceitar",
        declineBtn: "Recusar",
      },
      controlConfirm: {
        text: "Um atendente deseja controlar esta página para ajudar você. Permitir?",
        confirmBtn: "Permitir",
        declineBtn: "Recusar",
      },
      recordingConfirm: {
        text: "Um atendente deseja gravar a atividade nesta página. Permitir?",
        confirmBtn: "Permitir",
        declineBtn: "Recusar",
      },
    }));

    const result = await tracker.start();
    if (!result.success) {
      disableCheckoutEvents();
      console.warn("[OpenReplay] Não foi possível iniciar a sessão.");
      return;
    }

    syncCheckoutContext(tracker);
    connectCheckoutEvents(tracker);
  } catch {
    disableCheckoutEvents();
    // Uma falha na observabilidade não deve impedir a compra.
    console.warn("[OpenReplay] Não foi possível iniciar a sessão.");
  }
}
